import { Property } from 'csstype'

export interface ParagraphInterface {
  maxWidth: Property.MaxWidth<string>
}

export const paragraph: ParagraphInterface = {
  maxWidth: '35em',
}
